<template>
  <div class="tile">
    <h3 class="content__heading">Licensing</h3>
    <span ref="tooltip" class="tooltip">{{ hoverState }}</span>
    <div class="states--grid">
      <radio-svg-map v-model="selectedState" :map="USA" />
      <div>
        <p
          v-if="selectedStateLong"
          class="text__center text__bold m-tb-small"
        >{{ selectedStateLong }} Licenses</p>
        <p v-else class="text__center text__bold m-tb-small">Select a State</p>
        <div class="licenses--border">
          <simplebar class="licenses--overflow" data-simplebar-auto-hide="false">
            <p v-if="licensedOfficers.length === 0" class="text__center">No Loan Officers</p>
            <ul v-else class="licenses--list">
              <li
                v-for="officer in licensedOfficers"
                :key="officer.nmls"
                class="flex__between tile--row"
              >
                <a :href="`mailto: ${officer.email}`">{{ officer.name }}</a>
                <span>{{ officer.nmls }}</span>
              </li>
            </ul>
          </simplebar>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { RadioSvgMap } from "vue-svg-map";
import { mapGetters } from "vuex";
import USA from "@svg-maps/usa";
export default {
  components: {
    RadioSvgMap
  },
  data() {
    return {
      USA,
      selectedState: null,
      selectedStateLong: null,
      hoverState: null
    };
  },
  computed: {
    ...mapGetters({
      licensesData: "loanOfficers/getLicensesData"
    }),
    licensedOfficers() {
      return this.licensesData.filter(officer => {
        return officer.short.toLowerCase() === this.selectedState;
      });
    }
  },
  mounted() {
    const that = this;
    const tooltip = this.$refs.tooltip;
    const states = document.querySelectorAll("path");
    states.forEach(state => {
      state.addEventListener("mouseover", event => {
        that.hoverState = event.target.getAttribute("aria-label");
        tooltip.style.display = "block";
        tooltip.style.top = `${event.clientY - 20}px`;
        tooltip.style.left = `${event.clientX + 20}px`;
      });
      state.addEventListener("mouseout", () => {
        that.hoverState = null;
        tooltip.style.display = "none";
      });
      state.addEventListener("click", event => {
        that.selectedStateLong = event.target.getAttribute("aria-label");
      });
    });
  }
};
</script>

<style lang="scss">
.tooltip {
  color: #000;
  position: fixed;
  display: none;
  font-weight: bold;
  background-color: $grey;
  padding: 5px;
  border-radius: 5px;
}
.svg-map {
  stroke: #fff !important;
}
.svg-map__location {
  fill: $green !important;
}
.svg-map__location:focus,
.svg-map__location:hover {
  fill: $light-green !important;
  cursor: pointer !important;
}
.svg-map__location[aria-checked="true"] {
  fill: $dark-green !important;
}
.states--grid {
  @include grid($cols: 1fr, $row-gap: 15px);
}
.licenses--overflow {
  max-height: 150px;
}
.licenses--border {
  border: 2px dashed $dark-grey;
}
@media (min-width: $sm) {
  .licenses--list {
    @include grid($cols: repeat(2, 1fr), $col-gap: 30px);
  }
}
@media (min-width: $lg) {
  .states--grid {
    grid-template-columns: 5fr 2fr;
    grid-column-gap: 15px;
  }
  .licenses--list {
    grid-template-columns: 1fr;
    padding: 0 5px;
  }
  .licenses--overflow {
    max-height: 325px;
  }
}
</style>